import type { SiteCopyDto } from "../../types/SiteCopyDto";
import type { SiteCopyEntity } from "../../types/SiteCopyEntity";

export const SiteCopyEntityToCopyDto = ({ ...rest }: Readonly<SiteCopyEntity>): SiteCopyDto => {
    return { ...rest };
};
